import { KeyboardEvent, useCallback, useEffect, useMemo, useRef } from "react";

import { DateRange } from "react-day-picker";
import useUiuxStore from "src/store/useUiuxStore";
import { defaultSYS3050_R01Filter, SYS3050_R01Filter, useSYS3050_R01Store } from "src/containers/mes/SYS/SYS3050_R01/Store_SYS3050_R01";

import { getSYS3050_R01List, deleteSYS3050_R01, patchSYS3050_R01, createSYS3050_R01, downloadExcel_SYS3050_R01, getSYS3050_R01AllCount, getSYS3050_R01One } from "./Api_SYS3050_R01";
import { downloadExcel, downloadSettingExcel } from "src/utils/blob/blobUtil";
import { useLoadingSpinnerStore } from "src/store/util/loadingSpinnerUtil";
import useFetchActionbarAuth from "src/hooks/useFetchActionbarAuth";
import { validateString } from "src/utils/string/stringUtil";
import { showError, showSuccess, ShowSuccessFetch, showWarning } from "src/utils/toast/toastUtil";
import { useCommonCodeStore } from "src/store/useCommonCodeStore";
import { refetchUpdateList } from "src/utils/axios/reFetch";
import { defaultSYS3050_R01Dto, SYS3050_R01Dto } from "./Dto_SYS3050_R01";
import { AgGridReact } from "ag-grid-react";
import { fetchDataSetHandler, fetchFilterConfig, gridRefSelectedRowHandler, fetchFilterConfig_refetch, fetchDataSetHandler_refetch } from "src/utils/grid/GridHandlerContent";

interface Props {
	gridRef: React.RefObject<AgGridReact<SYS3050_R01Dto> | null>;
}

type FetchMessageMode = 'show' | 'none';

interface FetchOptions {
	messageMode?: FetchMessageMode;
}

export const SYS3050_R01Content = (props: Props) => {

	const {
		gridRef,
	} = props;

	const { 
		defalutDateRange, 
		SYS3050_R01Filter, setSYS3050_R01Filter, 
		SYS3050_R01PastFilter, setSYS3050_R01PastFilter,
		SYS3050_R01List, setSYS3050_R01List,
		selectedSYS3050_R01, setSelectedSYS3050_R01,
		editSYS3050_R01, setEditSYS3050_R01,
		insertSYS3050_R01List,
		removeSYS3050_R01List,
		updateSYS3050_R01List,
		allCount, setAllCount,
		initData,
		setScrollTop,
	} = useSYS3050_R01Store();
	
	const { 
		compCdList,
		empstsCdList,
		compJoinTpList,
		jjCdList,
		jwCdList,
		jcCdList,
		payTpList,
		retireTypeList,
		birthdayTypeList,
		countryCdList,
		carTypeList,
		educationTypeList,
		yesNoList,
		orgCdList,
		fetchEmployeeCdCode
	} = useCommonCodeStore();

	useFetchActionbarAuth("SYS3050_R01");

	const { setMessage } = useUiuxStore();
	const { setLoadingSpinner } = useLoadingSpinnerStore();
	
	const handleExcelClick = useCallback(async () => {
		setLoadingSpinner(true);

		const response = await downloadExcel_SYS3050_R01(
			'',
			getParams(SYS3050_R01Filter),
			SYS3050_R01List.length ?? 0
		);

		downloadSettingExcel({ responseData: response.data.data, fileName: '사원정보등록-excel.xlsx' });

		setLoadingSpinner(false);
	
	}, [SYS3050_R01Filter, SYS3050_R01List, setLoadingSpinner]);

	const getParams = (filter: Partial<SYS3050_R01Filter>) => {
		return {
			compCd: filter.compCd,
			orgCd: filter.orgCd,
			empSts: filter.empSts,
			date: filter.date,
		};
	}

	const renewalAllCount = useCallback(async () => {
		const allCountResponse = await getSYS3050_R01AllCount(getParams(SYS3050_R01Filter));
		setAllCount(allCountResponse.data.data);
		return allCountResponse.data.data;
	}, [SYS3050_R01Filter, setAllCount]);

	const fetchData = useCallback(async (arg?: FetchOptions | KeyboardEvent<HTMLInputElement>) => {
		const messageMode = arg && typeof arg === 'object' && 'messageMode' in arg
			? arg.messageMode ?? 'show'
			: 'show';
		setLoadingSpinner(true);
		if (messageMode === 'show') {
			setScrollTop(null);
		}

		const response = await getSYS3050_R01List(
			'',
			getParams(SYS3050_R01Filter),
			SYS3050_R01List.length ?? 0
		);

		let newList = [...response.data.data ]
		setSYS3050_R01List(newList);

		const processAllCount = await renewalAllCount();
		if (newList.length > 0) {
			gridRefSelectedRowHandler(
				gridRef,
				setSelectedSYS3050_R01,
				() => true,// () => !data.find(value => value.empNo === selectedSYS3050_R01?.empNo)
			);
			if (messageMode === 'show') {
				ShowSuccessFetch(setMessage, `조회가 완료되었습니다. (총 ${newList.length}/${processAllCount}건)`);
				setTimeout(() => setMessage(""), 5000);
			}
		} else {
			if (messageMode === 'show') {
				showWarning('조회된 데이터가 없습니다.', 3000);
			}
		}
		setSYS3050_R01PastFilter(SYS3050_R01Filter);
		setLoadingSpinner(false);
		return newList;
	}, [SYS3050_R01Filter, SYS3050_R01List, gridRef, editSYS3050_R01, setSYS3050_R01List, setSelectedSYS3050_R01, setScrollTop]);

	const fetchOne = useCallback(async () => {
		if (!selectedSYS3050_R01) return;
		setLoadingSpinner(true);
		try {
			const response = await getSYS3050_R01One(selectedSYS3050_R01.empNo);
			setEditSYS3050_R01({ ...selectedSYS3050_R01, ...response.data.data });
		} catch (error) {
			console.error("조회 중 오류 발생:", error);
			showError("조회 중 오류가 발생했습니다.");
		}
		setLoadingSpinner(false);
	}, [SYS3050_R01Filter, setEditSYS3050_R01, selectedSYS3050_R01]);


	const defaultSYS3050_R01Row = useCallback(() => {
		return {
			...defaultSYS3050_R01Dto,
			empSts: empstsCdList[0].minorCd,
			compJoinType: compJoinTpList[0].minorCd,
			compCd: compCdList[0].compCd,
			// orgCd = orgCdList[0].orgCd;
			jobClass: jjCdList[0].minorCd,
			positionCd: jwCdList[0].minorCd,
			jobPosition: jcCdList[0].minorCd,
			payType: payTpList[0].minorCd,
			retireType: retireTypeList[0].minorCd,
			birthdayType: birthdayTypeList[0].minorCd,
			educationLevel: educationTypeList[0].minorCd,
			meritPersonYn: yesNoList[0].minorCd,
			carType: carTypeList[0].minorCd,
			foreignYn: yesNoList[0].minorCd,
			country: countryCdList[0].minorCd,
			inserted: true,
		}
	}, [defaultSYS3050_R01Dto]);

	const initContainerData = useCallback(async () => {
		initData();
	}, [initData, setMessage]);
	
	const handleCreateClick = useCallback(async () => {
		setEditSYS3050_R01(defaultSYS3050_R01Row());
		setSelectedSYS3050_R01(undefined);
	}, []);
	
	const handleDeleteClick = useCallback(async () => {
		if (!selectedSYS3050_R01) {
			showWarning('선택된 직원이 없습니다.');
			return;
		}
	
		if (!window.confirm('정말로 삭제하시겠습니까?')) {
			return;
		}
	
		await deleteSYS3050_R01(selectedSYS3050_R01.empNo);
		removeSYS3050_R01List(selectedSYS3050_R01.empNo);
		showSuccess(`${selectedSYS3050_R01.empNo} 직원 삭제가 완료되었습니다.`)
		refetchUpdateList('delete', defaultSYS3050_R01Dto, selectedSYS3050_R01, 'empNo', SYS3050_R01List, setSYS3050_R01List);
		// 삭제 후에는 서버 기준의 최신 리스트로 전체 재조회
		fetchData({ messageMode: 'none' });
	}, [selectedSYS3050_R01, fetchData]);

	const validateInsertData = (data: SYS3050_R01Dto ) => {
		if (!editSYS3050_R01) {
			setMessage('수정할 데이터가 없습니다.');
			return false;
		}

		if (!validateString(data.empNo))			{ showWarning('사원번호를 입력해주세요.');				return false; }
		if (!validateString(data.empNm))			{ showWarning('사원명을 입력해주세요.');				return false; }
		if (!validateString(data.ename))			{ showWarning('영문이름을 입력해주세요.');				return false; }
		if (!validateString(data.cname))			{ showWarning('중문이름을 입력해주세요.');				return false; }
		if (!validateString(data.compCd))			{ showWarning('사업장코드를 입력해주세요.');			return false; }
		if (!validateString(data.orgCd))			{ showWarning('부서코드를 입력해주세요.');				return false; }
		if (!validateString(data.empSts))			{ showWarning('재직상태를 입력해주세요.');        		return false; }
		if (!validateString(data.compCd))			{ showWarning('근무지역(사업장코드)을 입력해주세요.');	return false; }
		if (!validateString(data.positionCd))		{ showWarning('직위코드를 입력해주세요.');				return false; }
		if (!validateString(data.jobClass))			{ showWarning('직군을 입력해주세요.');					return false; }
		if (!validateString(data.jobPosition))		{ showWarning('직책을 입력해주세요.');					return false; }
		if (!validateString(data.post))				{ showWarning('우편번호를 입력해주세요.');				return false; }
		if (!validateString(data.address))			{ showWarning('주소를 입력해주세요.');					return false; }
		if (!validateString(data.detailAddress))	{ showWarning('상세주소를 입력해주세요.');				return false; }
		if (!validateString(data.email))			{ showWarning('이메일을 입력해주세요.');				return false; }
		if (!validateString(data.mobileNo))			{ showWarning('휴대폰번호를 입력해주세요.');			return false; }
		return true;
	}

	const handleSaveClick = useCallback(async () => {
		if (!editSYS3050_R01) return;
		
		if (!validateInsertData(editSYS3050_R01)) {
			return;
		}
		
		let processName = '';
		let responseData: SYS3050_R01Dto = { ...defaultSYS3050_R01Row() };

		// retireDt가 undefined인 경우 기본값 설정 (9999-12-31)
		const processedEditData = editSYS3050_R01 ? {
			...editSYS3050_R01,
			retireDt: editSYS3050_R01.retireDt || '9999-12-31'
		} : editSYS3050_R01;

		if (selectedSYS3050_R01 && processedEditData) {
			processName = 'patch';
			const response = await patchSYS3050_R01([processedEditData]);
			responseData = response.data.data[0];
			if (response && response.data) {
				if (response.data.successFlag) {
					showSuccess(`${processedEditData?.empNo} 직원 수정이 완료되었습니다.`)
					setMessage(`${processedEditData?.empNo} 직원 수정이 완료되었습니다.`)
				}else return;
			}
		} else if (processedEditData) {
			processName = 'post';
			const response = await createSYS3050_R01(processedEditData);
			responseData = response.data.data[0];
			if (response && response.data) {
				if (response.data.successFlag) {
					showSuccess(`${processedEditData?.empNo} 직원 등록이 완료되었습니다.`)
					setMessage(`${processedEditData?.empNo} 직원 등록이 완료되었습니다.`)
				}else return;
			}
		}
	
		setTimeout(() => {
			setMessage("");
		}, 5000)
	
		if(processedEditData) {
			refetchUpdateList(processName, responseData, processedEditData, 'empNo', SYS3050_R01List, setSYS3050_R01List);
			// const result = await getPartSYS3050_R01List(processedEditData.empNo);
			// refetchUpdateList(result.data.data, processedEditData, 'empNo', SYS3050_R01List, setSYS3050_R01List);
		}
		fetchEmployeeCdCode();
		// 저장 후에는 서버 기준의 최신 리스트로 전체 재조회하며 방금 편집한 사원을 재선택
		fetchData({ messageMode: 'none' });
	}, [selectedSYS3050_R01, editSYS3050_R01, renewalAllCount, fetchData]);

	useEffect(() => {
		if (selectedSYS3050_R01) {
			fetchOne();
		}else{
			setEditSYS3050_R01(defaultSYS3050_R01Row());
		}
	}, [selectedSYS3050_R01]);


	return {
		handleExcelClick,
		fetchData,
		defaultSYS3050_R01Row,
		initContainerData,
		handleCreateClick,
		handleDeleteClick,
		handleSaveClick,
	}
}
